import {
  Box,
  Chip,
  CircularProgress,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from '@mui/material'
import { ChevronRight } from '@mui/icons-material'
import NotificationsActiveRounded from '@mui/icons-material/NotificationsActiveRounded'
import { useTranslation } from 'react-i18next'
import { useDeadLetterSubscriptions } from '@src/tools/dead-letter/api/dead-letters-api'

interface SubscriptionSidebarProps {
  selectedSubscription: string | null
  onSelectSubscription: (subscriptionName: string) => void
}

const SubscriptionSidebar = ({ selectedSubscription, onSelectSubscription }: SubscriptionSidebarProps) => {
  const { t } = useTranslation()
  const [subscriptions, loadingSubscriptions] = useDeadLetterSubscriptions()

  return (
    <Box sx={{ width: 400, minWidth: 400, borderRight: 1, borderColor: 'divider', overflow: 'auto', height: '100%' }}>
      <List dense>
        <ListSubheader>{t('deadLetters.title')}</ListSubheader>
        {loadingSubscriptions && <CircularProgress size={24} sx={{ ml: 2 }} />}
        {!loadingSubscriptions && subscriptions.length === 0 && (
          <ListItemText
            primary={t('deadLetters.noDeadLetters')}
            sx={{ px: 2, py: 2, textAlign: 'center', color: 'text.secondary' }}
          />
        )}
        {subscriptions.map((sub) => (
          <ListItemButton
            key={sub.subscriptionName}
            selected={selectedSubscription === sub.subscriptionName}
            onClick={() => onSelectSubscription(sub.subscriptionName)}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <NotificationsActiveRounded
                fontSize="small"
                color={sub.eventCount > 0 ? 'primary' : 'disabled'}
              />
            </ListItemIcon>
            <ListItemText primary={sub.subscriptionName} />
            <Chip
              size="small"
              label={sub.eventCount}
              color={sub.eventCount > 0 ? 'error' : 'success'}
              sx={{ borderRadius: '12px', fontWeight: 600, minWidth: 32 }}
            />
            <ChevronRight fontSize="small" sx={{ ml: 0.5, color: 'text.disabled' }} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  )
}

export default SubscriptionSidebar
